import { Box, Typography } from "@mui/material";

export default function StatTile({ count, label, outOf = null }) {
  return (
    <Box
      sx={{
        backgroundColor: (theme) => theme.palette.secondary.main,
        borderRadius: 1,
        p: 1,
        display: "flex",
        flex: 1,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        alignSelf: "stretch",
      }}
    >
      {outOf == null ? (
        <Typography sx={{ fontSize: 24, fontWeight: "bold", lineHeight: 1 }}>
          {count}
        </Typography>
      ) : (
        <Typography
          sx={{
            fontSize: 24,
            fontWeight: "bold",
            lineHeight: 1,
            textAlign: "center",
          }}
        >
          {count}
          <Typography
            component="span"
            sx={{
              fontSize: 18,
              color: "text.secondary",
              fontWeight: "medium",
            }}
          >
            /{outOf}
          </Typography>
        </Typography>
      )}

      <Typography variant="body2" sx={{ lineHeight: 1, textAlign: "center" }}>
        {label}
      </Typography>
    </Box>
  );
}
